export const state = {
  products: [],
  groups: [],
  sorts: [],
  categories: [],
  packings: [],
  brands: []
}
